import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { App } from './App';
import ErrorBoundaryComponent from './components/Errors/ErrorBoundary/ErrorBoundaryComponent';
import { APP_ROOT_ID } from './stores/constants';
import style from './index.module.scss';

const rootElement = document.getElementById(APP_ROOT_ID);

if (rootElement?.hasChildNodes()) {
    hydrateRoot(
        rootElement,
        <span className={style.root}>
            <ErrorBoundaryComponent>
                <App />
            </ErrorBoundaryComponent>
        </span>,
    );
} else {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(rootElement!);
    root.render(
        <span className={style.root}>
            <ErrorBoundaryComponent>
                <App />
            </ErrorBoundaryComponent>
        </span>,
    );
}
